import React, { useEffect, useState } from 'react'
import { Button, Col, Collapse, Row, Space, Switch } from 'antd'
import { connect, useDispatch } from 'react-redux'
import { selectCurrentUser } from 'Store/user/selector'
import RootState from 'typings/RootState'
import styled from 'styled-components'
import { DefaultStatus } from 'helpers/constanst'
import { StatusTag } from 'Components/utilities'
import { DelteStockConfigReq, StockConfigData, StockProductConfig } from 'Store/stock/types'
import { cloneDeep } from 'lodash'
import ConfigForm from './ConfigForm'
import { ActionButton } from 'Components/button'
import { DeleteOutlined, PlusOutlined } from '@ant-design/icons'
import { ConfirmDailog, EventModal } from 'Components/modal'
import theme, { MyTheme } from 'Components/common/Theme'
import { clearEventAction } from 'Store/stock/actions'
import { selectDelteConfigEvent } from 'Store/stock/selector'
import { deleteConfigStockAPI } from 'Store/stock/api'
const { Panel } = Collapse

type Props = {
  data: StockConfigData[]
  onUpdate: (data: StockConfigData[]) => void
  onUpdateStatus: (isActive: boolean) => void
  isActive: boolean
  isTutorial?: boolean
} & ReduxProps

const CustomProductConfig: React.FunctionComponent<Props> = props => {
  const { onUpdate, data, event, currentUser, isActive, onUpdateStatus, isTutorial } = props
  const dispatch = useDispatch()

  const initForm = {
    id: 0,
    is_all_product: 'no',
    merchant_id: 0,
    products: [],
    min_qty: 0,
    status: DefaultStatus.ACTIVE,
  } as StockConfigData

  const [formData, setFormData] = useState([] as StockConfigData[])
  const [confirmDeleteDialog, setConfirmDeleteDialog] = useState(false)
  const [selectedCondition, setSelectedCondition] = useState(undefined as StockConfigData | undefined)
  const [selecteIndex, setSelecteIndex] = useState(0)
  const [activeKey, setActiveKey] = useState([] as any)

  const onDelete = (id: number): void => {
    const req: DelteStockConfigReq = {
      id: id,
    }
    dispatch(deleteConfigStockAPI(req, currentUser.accessToken, currentUser?.activeMerchant?.uuid || ''))
  }

  useEffect(() => {
    if (data) {
      setFormData([...data])
    }
  }, [data])

  useEffect(() => {
    if (data) {
      setActiveKey(1)
    }
  }, [isTutorial])

  const onUpdateData = (newdata: StockConfigData, index: number) => {
    const data = cloneDeep(formData) as StockConfigData[]
    data[index] = newdata
    setFormData(data)
    onUpdate(data)
  }

  const onConfirmDelete = () => {
    setConfirmDeleteDialog(false)
    if (selectedCondition?.id) {
      onDelete(selectedCondition?.id || 0)
    } else {
      ondeleteByIndex(selecteIndex)
    }
  }

  const ondeleteByIndex = (deleteIndex: number) => {
    const newData = formData?.filter((item, index) => index !== deleteIndex)
    setFormData(newData)
    onUpdate(newData)
  }

  const ondeleteById = (id: number) => {
    const newData = formData?.filter(item => item?.id !== id)
    setFormData(newData)
    onUpdate(newData)
  }

  const clearEvent = (): void => {
    dispatch(clearEventAction())
    setSelectedCondition(undefined)
    setSelecteIndex(0)
  }

  const onDeleteSuccess = (): void => {
    ondeleteById(selectedCondition?.id || 0)
    clearEvent()
  }

  const onAddCondition = () => {
    const init = cloneDeep(initForm)
    const newData = {
      ...init,
    }
    const data = cloneDeep(formData) as StockConfigData[]
    data.push(newData)
    setFormData(data)
    onUpdate(data)
    setActiveKey(data.length)
  }

  const LoadingModal = (
    <EventModal event={[event]} enable={true} successCalback={onDeleteSuccess} errorCalback={clearEvent} />
  )

  const getTitle = (isActive: boolean) => (
    <TitleWrapper className="ttr-special">
      <Row justify="space-between">
        <Col>
          <Space align="start">
            <Switch checked={isActive} onChange={val => onUpdateStatus(val)} />
            <Title>แจ้งเตือนสต๊อกขั้นต่ำแบบกำหนดสินค้าเอง</Title>
            <StatusTag isPass={isActive === true} text={isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} />
          </Space>
        </Col>
      </Row>
    </TitleWrapper>
  )

  const genDeletIcon = (data: StockConfigData, index: number) => (
    <ActionButton
      text=""
      icon={<DeleteOutlined />}
      label="ลบเงื่อนไข"
      action="deleted"
      onClick={event => {
        event?.stopPropagation()
        setConfirmDeleteDialog(true)
        setSelectedCondition(data)
        setSelecteIndex(index)
      }}
    />
  )

  const ConfirmDeleteModal = (
    <ConfirmDailog
      title={'ยืนยันการลบ'}
      isShow={confirmDeleteDialog}
      handleOk={onConfirmDelete}
      handleCancel={() => setConfirmDeleteDialog(false)}
    />
  )

  const getDisableProduct = (currentIndex: number) => {
    const products = [] as StockProductConfig[]
    data?.forEach((item, index) => {
      if (index !== currentIndex) {
        item?.products?.forEach(product => {
          products.push(product)
        })
      }
    })
    return products
  }

  const getDefaultActiveIndex = (data: StockConfigData[]) => {
    const number = [] as number[]
    for (let index = 0; index < data.length; index++) {
      number.push(index + 1)
    }
    return number
  }

  return (
    <Row gutter={[16, 16]}>
      {ConfirmDeleteModal}
      {LoadingModal}
      <Col span={24}>{getTitle(isActive)}</Col>
      <Col span={24}>
        {isActive && (
          <Collapse
            collapsible="header"
            bordered={true}
            defaultActiveKey={getDefaultActiveIndex(data)}
            activeKey={activeKey}
            accordion={false}
            //ghost
            expandIconPosition={'left'}
            style={{ backgroundColor: '#fff' }}
            onChange={setActiveKey}
          >
            {formData &&
              data.map((data, index: number) => {
                const disableProduct = getDisableProduct(index)
                return (
                  <Panel
                    style={{ background: theme.colors.whitebg }}
                    header={
                      <Row justify="space-between" align="middle" gutter={[12, 12]}>
                        <Col span={18}>
                          <div>
                            แจ้งเตือนเมื่อสต๊อกของสินค้าคงเหลือต่ำกว่า &nbsp;
                            {data?.min_qty || 0}&nbsp; หน่วย&nbsp;
                            <ProductCount> (สินค้าที่แจ้งเตือน {data?.products?.length} รายการ)</ProductCount>
                          </div>
                        </Col>
                        <Col className="ttr-delete-condition">{genDeletIcon(data, index)}</Col>
                      </Row>
                    }
                    key={index + 1}
                  >
                    <ConfigForm
                      data={data}
                      onUpdate={data => onUpdateData(data, index)}
                      addProduct={true}
                      disableProduct={disableProduct}
                      key={index}
                    />
                  </Panel>
                )
              })}
          </Collapse>
        )}
      </Col>
      {isActive && (
        <Col span={24} className="ttr-add-condition">
          <Button type="dashed" block onClick={onAddCondition} icon={<PlusOutlined />}>
            เพิ่มเงื่อนไข
          </Button>
        </Col>
      )}
    </Row>
  )
}

const ProductCount = styled.span`
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
`

const TitleWrapper = styled.div``

const Title = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body3};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.black};
  margin-bottom: 5px;
`

const mapStateToProps = (state: RootState) => {
  return {
    currentUser: selectCurrentUser(state),
    event: selectDelteConfigEvent(state),
  }
}

type ReduxProps = ReturnType<typeof mapStateToProps>

export default connect(mapStateToProps)(CustomProductConfig)
